import React from "react";

import { type IconDefinition } from "@fortawesome/fontawesome-svg-core";

import { Icon, Text } from "@performyard/py-components";

type StatCardColor = "blue" | "green" | "orange";

const colorClasses: Record<StatCardColor, string> = {
	blue: "bg-primary-6",
	green: "bg-green-5",
	orange: "bg-orange-5",
};

type Props = {
	value: number;
	label: string;
	icon: IconDefinition;
	color: StatCardColor;
};

const StatCard: React.FC<Props> = ({ value, label, icon, color }) => {
	return (
		<div className="box-border flex h-[136px] flex-1 items-center gap-4 rounded-2 border border-solid border-neutral-2 bg-neutral-0 px-6 py-4">
			<div className={`flex h-14 w-14 shrink-0 items-center justify-center rounded-2 ${colorClasses[color]}`}>
				<Icon icon={icon} size={32} color="neutral-0" aria-hidden="true" />
			</div>
			<div className="flex flex-col">
				<Text
					size="paragraph-1"
					dangerouslySetClassName="text-[48px] font-semibold leading-[56px] text-neutral-9"
				>
					{value.toLocaleString()}
				</Text>
				<Text size="paragraph-2" dangerouslySetClassName="text-[18px] leading-6 text-neutral-9">
					{label}
				</Text>
			</div>
		</div>
	);
};

export default StatCard;
